import { Injectable, OnDestroy } from '@angular/core';
import { NgbDateAdapter, NgbDatepickerI18n, NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { PtCoreSelectors } from '@pt/pt-core';
import { TranslationWidth } from '@angular/common';

export interface DateTime extends NgbDateStruct, NgbTimeStruct {
}

@Injectable()
export class NgbEpochDateStringAdapter extends NgbDateAdapter<number> {
  fromModel(date: number | Date): DateTime | null {
    if (!!date) {
      const d = new Date(date);
      return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds()
      };
    } else {
      return null;
    }
  }

  toModel(date: NgbDateStruct | null): number | null {
    return date ? new Date(Date.UTC(date.year, date.month - 1, date.day, 0, 0, 0)).getTime() : null;
  }
}

@Injectable()
export class NgbDatePickerI18nAdapter extends NgbDatepickerI18n implements OnDestroy {

  public currentLanguage$ = this.store.select(PtCoreSelectors.currentLanguage);
  weekdayShortNameLocale: Map<string, string[]> = new Map<string, string[]>().set(
    'it', ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom']
  ).set(
    'en', ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  );
  monthShortNameLocale: Map<string, string[]> = new Map<string, string[]>().set(
    'it', ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
  ).set(
    'en', ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  );
  monthFullNameLocale: Map<string, string[]> = new Map<string, string[]>().set(
    'it', ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Setttembre', 'Ottobre', 'Novembre', 'Dicembre']
  ).set(
    'en', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  );
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private lang;

  constructor(private store: Store<any>) {
    super();
    this.currentLanguage$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => this.lang = t);
  }

  getWeekdayShortName(weekday: number): string {
    return this.weekdayShortNameLocale.get(this.lang)[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return this.monthShortNameLocale.get(this.lang)[month - 1];
  }

  getMonthFullName(month: number): string {
    return this.monthFullNameLocale.get(this.lang)[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return 'e';
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    return this.weekdayShortNameLocale.get(this.lang)[weekday - 1];
  }
}
